import * as React from 'react'
import BannerMap from '../info/banner-map';
import { displayShortened, formatPhone } from "../../utility/api-utilities";

function ProgramProfile(props) {
    const school = props.school;
    const sortedPrograms = school.summerPrograms.sort((a, b) => {
        let aName = a.name;
        if (aName == 'HS Credit Recovery' || aName == 'Local Programming') {
            aName = `${a.name} - ${a.programCategories}`
        }
        let bName = b.name;
        if (bName == 'HS Credit Recovery' || bName == 'Local Programming') {
            bName = `${b.name} - ${b.programCategories}`
        }
        return aName.localeCompare(bName)
    });

    return (school ? <div className="bs-shim prog-profile">
        {<div className="padded-page-header">
            <BannerMap school={school} height="225px" />
        </div>}
        <div className="main-overview container-fluid">
            <div className="row main-school-info">
                <div className="col-sm-9">
                    <div className="content">
                        <h2>{school.title}</h2>
                        <p><strong>Address: </strong>{school.address}</p>
                        {school.phoneNumber && <p><strong>Phone: </strong>{formatPhone(school.phoneNumber)}</p>}
                        {school.websiteURL && <p><strong>Website: </strong><a target="_blank" href={school.websiteURL}>{school.websiteURL}</a></p>}
                    </div>
                </div>
                <div className="col-sm-3 prek-profile-buttons">
                    {school.websiteURL && <a className="btn" target="_blank" href={school.websiteURL} >View Website</a>}
                    {/*<a className="btn" target="_blank" href={getDirectionsUrl(`${school.Address}, ${school.City} ${school.PostalCode}`)}>Directions</a>*/}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="summer-programs">
                        <div className="table-scrolling-wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Program</th>
                                        <th>Grade</th>
                                        <th>Duration</th>
                                        <th>Time</th>
                                        <th>Days</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sortedPrograms.map((program, i) => {
                                        let displayName = program.name;
                                        if (program.name == 'HS Credit Recovery' || displayName == 'Local Programming' || program.name == 'CTE Summer Camps') {
                                            displayName = `${program.name} - ${program.programCategories}`
                                        }
                                        return <>
                                            <tr key={`program${program.code}`}>
                                                <td>
                                                    <h3 className={"h4-style"}>{displayName}</h3>
                                                    <p dangerouslySetInnerHTML={{ __html: program.description }}></p>
                                                    {program.primaryContact ? <p>Contact: {program.primaryContact}</p> : <></>}
                                                </td>
                                                <td>{program.gradesServed}</td>
                                                <td>{displayShortened(program.startDate)}{program.endDate ? ` - ${displayShortened(program.endDate)}` : ''}</td>
                                                <td>{program.startTime}{program.endTime ? ` - ${program.endTime}` : ''}</td>
                                                <td>{displayShortened(program.durationDays)}</td>
                                            </tr>
                                        </>
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> : <></>);
}

export default ProgramProfile;